import { type ReactNode } from "react";
import { Logo } from "@/components/Logo";

export function ViewerShell({ children, footerNote }: { children: ReactNode; footerNote?: string }) {
  return (
    <div className="min-h-screen flex flex-col bg-viewer-bg text-white">
      <header className="px-6 pt-8 pb-4 flex flex-col items-center gap-1">
        {/* Gold wordmark — the full-logo PNG is drawn for light surfaces. */}
        <Logo variant="wordmark" className="text-4xl" />
        <span className="text-[10px] tracking-[0.3em] uppercase text-gold/80">Just for you</span>
      </header>
      <main className="flex-1 flex items-stretch justify-center px-4 py-2">
        <div className="w-full max-w-3xl">{children}</div>
      </main>
      <footer className="p-6 text-center text-xs text-navy-200 tracking-wider">
        {footerNote ?? "demore — just for you"}
      </footer>
    </div>
  );
}
